export default "/assets/3d4f7aec797ee8de.svg"